exports["RU"] = require("./RU.js");
exports["GR"] = require("./GR.js");
exports["UA"] = require("./UA.js");
exports["NO"] = require("./NO.js");
exports["AM"] = require("./AM.js");